// @flow
import { SuspenseWithPerf } from "reactfire";
import AppHeader from "../../components/AppHeader";
import React from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import Helmet from "react-helmet";
import RankingsTable from "./RankingsTable";
import Box from "@material-ui/core/Box";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Accordion from "@material-ui/core/Accordion";

function Rankings() {
  return (
    <>
      <Helmet>
        <title>Tabelle - SG Coesfeld 06</title>
      </Helmet>
      <AppHeader title="Tabelle" />
      <Container maxWidth="sm">
        <SuspenseWithPerf traceId="Rankings" fallback={<RankingsSkeleton />}>
          <RankingsTable />
        </SuspenseWithPerf>
      </Container>
    </>
  );
}

function RankingsSkeleton() {
  const SkeletonRows = Array.from({ length: 13 }, (v, i) => i);
  return (
    <>
      {SkeletonRows.map((r, index) => (
        <Accordion
          TransitionProps={{ unmountOnExit: true }}
          key={`${r}${index}`}
        >
          <AccordionSummary>
            <Skeleton variant="rect" width="100%" height={40} />
          </AccordionSummary>
        </Accordion>
      ))}
      <Box mt={1}>
        <Typography variant="caption" color="textSecondary">
          <b>SP:</b> Spiele, <b>S:</b> Siege, <b>N:</b> Niederlagen, <b>Pt:</b>{" "}
          Punkte
          <br />
          Graphen zeigen den Verlauf der Platzierung pro Woche.
          <br />
          Stand:
        </Typography>
      </Box>
    </>
  );
}

export default Rankings;
